import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import { Link } from "react-router";

export const dataAccordion = [
  {
    id: 1,
    title: `چگونه میتوانم کارت فیزیکی   پولی پی را داشته باشم؟`,
    description: (
      <>
        شما میتوانید با مراجعه حضوری به گیشه های پولی پی
        موجود در محل زندگی خود، کارت فیزیکی خود را دریافت نمایید. لیست گیشه‌های{" "}
        پولی پی را از{" "}
        <Link to="/locations" style={{ color: "#1976d2" }}>
          اینجا
        </Link>
        ببینید.
      </>
    ),
  },
  {
    id: 2,
    title: `اعتبار دریافتی از   پولی پی را در کجا میتوان استفاده کرد؟`,
    description: (
      <>
        اعتبار دریافتی از سامانه پولی پی تنها در پذیرنده های
        طرف قرارداد با پولی پی قابل استفاده میباشد. لیست
        پذیرنده های پولی پی را از .{" "}
        <Link to="/locations/merchant" style={{ color: "#1976d2" }}>
          اینجا
        </Link>
        ببینید.
      </>
    ),
  },
  {
    id: 3,
    title: `آیا میتوان اعتبار   پولی پی را به صورت پول نقد دریافت کرد؟`,
    description: `خیر. اعتبارات دریافتی در سامانه   پولی پی تنها به صورت موجودی اعتباری در کیف پول اعتباری  پولی پی قرار دارد و تنها از طریق دستگاه های کارتخوان پذیرنده پولی پی قابل استفاده میباشد.`,
  },
  {
    id: 4,
    title: "حداقل و حداکثر زمان بازپرداخت اقساط به چه صورت میباشد",
    description: `حداقل زمان بازپرداخت 1 ماه میباشد که در صورت پرداخت 1 ماهه هیچ گونه کارمزدی به اعتبار دریافت شده تعلق نخواهد گرفت. بیشترین زمان بازپرداخت اقساط در  پولی پی نیز 12 ماه میباشد.`,
  },
  {
    id: 5,
    title: "در صورت به تعویق افتادن پرداخت اقساط چه اتفاقی می افتد؟",
    description: `در صورتی که اقساط پرداختی شما در سامانه  پولی پی به تعویق بیفتد علاوه بر جریمه نقدی ؛ بر سابقه امتیازات کاربر نیز تاثیر گذار خواهد بود. جریمه نقدی دیرکرد اقساط به ازای هر یک هفته 25 هزار ریال خواد بود و این مبلغ برای همه کاربران ثابت میباشد .`,
  },
  {
    id: 6,
    title: "امکان برداشت از کیف پول و واریز به کارت شتابی را ندارم",
    description:
      "برای انتقال وجه از کیف پول پولی پی به کارت های شتابی؛ در ابتدا باید کارت بانکی خود را در پنل کاربری خود ثبت نمایید. مورد دیگری که باید هنگام برداشت از کیف پول به آن توجه نمایید این است که شما امکان برداشت از کیف پول نقدی خود را دارید و اگر حساب نقدی شما کمتر از 25 هزار ریال باشد, امکان برداشت از کیف پول را نخواهید داشت.",
  },
  {
    id: 7,
    title: "امکان انتقال وجه و کارت به کارت ندارم",
    description:
      "لطفا ابتدا از وصل نبودن فیلتر شکن خود مطمئن شوید و سپس اتصال به شبکه اینترنت را بررسی نمایید. توجه داشته باشید که انتقال وجه تنها از کارت پولی پی به کارت پولی پی امکان پذیر میباشد. همچنین ممکن است در تنظیمات اکانت خود؛ مقدار مبلغ قابل برداشت در طول 24 ساعت را کاهش داده باشید.",
  },
  {
    id: 8,
    title: `دلیل کار نکردن کارت فیزیکی پولی پی چیست؟`,
    description: `امکان دارد حساب شما به دلیل ایجاد مشکلات مسدود شده باشد و یا کارت شما سوخته باشد. در صورت بروز این مشکل بهتر است به صورت حضوری به یکی از گیشه های معتبر پولی پی مراجعه نمایید.`,
  },
];
